import { useState, useCallback } from 'react';
import { OperationBC } from '../types';
import { accepterOffre, refuserOffre } from '../services/operationBcService';

// Resout l'id de commande d'un rang (meme logique que la branche acheteur d'OffreBC).
const resolveCommandeId = (operation: OperationBC, rang: number): number | undefined => {
  const cmd = (operation.commandes || []).find((c) => parseInt(String(c.rang), 10) === rang);
  return cmd?.id;
};

// Actions par rang de la case acheteur-BC, sur les bonnes routes /bdc/operation/*.
// Rafraichit l'etat React (refetch) au lieu de recharger toute la page.
export const useOperationBCActions = (operation: OperationBC, refetch: () => void) => {
  const [pending, setPending] = useState(false);

  const run = useCallback(
    async (rang: number, action: (operationId: number, commandeId: number) => Promise<unknown>) => {
      const commandeId = resolveCommandeId(operation, rang);
      if (commandeId === undefined) return;
      setPending(true);
      try {
        await action(operation.id, commandeId);
        refetch();
      } finally {
        setPending(false);
      }
    },
    [operation, refetch],
  );

  const accepter = useCallback((rang: number) => run(rang, accepterOffre), [run]);
  const refuser = useCallback((rang: number) => run(rang, refuserOffre), [run]);

  return { accepter, refuser, pending };
};
